
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    height: String,
    width: String,
  },
});
